import { MDBCol, MDBRow, MDBCard } from 'mdbreact';
import Carousel from 'react-multi-carousel';
import React from "react";
import 'react-multi-carousel/lib/styles.css';
import { withRouter } from "react-router-dom";
import { withTheme } from '../../themes/theming';
import KaizenPoint from './widgets/kaizenPoint';
import ActionItems from './widgets/actionItemsForDealers';
import DealerNoticeBoard from './widgets/dealerNoticeBoard';
import BestPracticeBoard from './widgets/dealerPracticeBoard';
import Activities from './widgets/activities';
import ActionItemReport from './widgets/ActionItemReport';
import Card from './widgets/card';
import AverageScoreChapter from './widgets/averageScoreChapter';
import ScoreTable from './widgets/scoreTable';
import ActionItemReportNAS from './widgets/ActionItemReportNAS';
//import DealerStatusNetwork from './widgets/dealerStatusNetwork';
import * as AppConst from '../../AppConstant';
import ProgressPerLocation from './widgets/progressPerLocation';
var I18n = require("react-redux-i18n").I18n;

class DealerWidgetContainer extends React.Component {
    /* eslint-disable */
    constructor(props) {
        super(props);
    }
    render() {
        const {userMdl} = this.props;
        const responsive = { 
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items:  this.props.userMdl.activeProgram !== 'TSM_SURVEYS' ? 7 : 5
            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 3
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 2
            }
        };

        return (
            <>
            {userMdl?.activeProgram !== AppConst.activeProgramNas && <div style={{paddingBottom:"1rem",paddingTop:"1rem"}}>
                <MDBRow className="mt-3 mb-5 mr-2">
                    <MDBCol lg="2" md="3">
                        <MDBCard className="dealer-scrollable-widgets">
                        <Activities userMdl={this.props.userMdl} />
                        </MDBCard>
                    </MDBCol>
                    <MDBCol lg="2" md="3">
                        <MDBCard className="dealer-scrollable-widgets">
                            <ActionItems userMdl={this.props.userMdl}/>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol lg="2" md="3">
                        <MDBCard className="dealer-scrollable-widgets">
                            <KaizenPoint userMdl={this.props.userMdl} />
                        </MDBCard>
                    </MDBCol>
                    <MDBCol lg="3" md="4">
                        <MDBCard className="dealer-dashboard-Notice-board">
                        <DealerNoticeBoard userMdl={this.props.userMdl} />
                        </MDBCard>
                    </MDBCol>
                    <MDBCol lg="3" md="5">
                        <MDBCard className="dealer-dashboard-Practice">
                        <BestPracticeBoard userMdl={this.props.userMdl}/>
                        </MDBCard>
                    </MDBCol>
                </MDBRow>


                <MDBRow className="mt-3 mb-5 mr-2">
                    <MDBCol>
                        <MDBCard className="dealer-dashboard-table">
                        <ActionItemReport userMdl={this.props.userMdl}/>
                        </MDBCard>
                    </MDBCol>
                </MDBRow>
            </div>}
            
            {/* NAS - dealer tiles - start here */}
            {
            userMdl?.activeProgram === AppConst.activeProgramNas &&
                <div className="dashboardDiv">
                  <Carousel
                      swipeable={false}
                      draggable={false}
                      showDots={false}
                      responsive={responsive}
                      infinite={false}
                      keyBoardControl={true}
                      customTransition="all .5"
                      transitionDuration={500}
                      containerClass="carousel-container"
                      itemClass="carousel-item-padding-40-px">
                      {/* NAS Dashboard Tiles - Starts from here*/}
                    {/* Assigned Location Tile */}
                    {userMdl?.activeProgram === AppConst.activeProgramNas && <MDBCard className="scrollable-widgets">
                        <Card 
                            theme={this.props.theme}
                            title={I18n.t('TopNav.AssignedLocation')}
                            existingProps={this.props}
                            name={AppConst.NAS_DASHBOARD_CARD.ASSIGNEDLOCATION}
                            isLexusValue={true} 
                            header={I18n.t('dashboardHeaders.AssignedLocationsElement')}
                            />
                    </MDBCard>}

                    {/* Score Tile */}
                    {userMdl?.activeProgram === AppConst.activeProgramNas && <MDBCard className="scrollable-widgets">
                        <Card 
                            theme={this.props.theme}
                            title={I18n.t('TopNav.Score')}
                            existingProps={this.props}
                            status={[
                                { value: "FIRST_AUDIT", label:  I18n.t('dashboardCards.FirstAudit') },
                                { value: "RE_AUDIT", label: I18n.t('dashboardCards.ReAudit') },
                            ]}
                            name={AppConst.NAS_DASHBOARD_CARD.SCORE}
                            isPercentage={true}
                            header={I18n.t('dashboardHeaders.ScoreTile')}
                            />
                    </MDBCard>}
                    {/* NAS Dashboard Tiles - Ends here*/}
                    </Carousel>

                    {userMdl?.activeProgram === AppConst.activeProgramNas && <MDBRow className="mt-3 mb-5 mr-2">
                    {/* Action items in progress element*/}
                        <MDBCol lg="12" md="12" className="ket-widget" style={{marginBottom:"25px"}}>
                            <ActionItemReportNAS userMdl={this.props.userMdl} existingProps={this.props} dealerOperations={this.props.dealerOperations || null}/>
                        </MDBCol>

                        <MDBCol lg="4" md="4" >
                            <MDBCol lg="12" md="12" className="ket-widget" >
                               <ProgressPerLocation customHeight="39rem" existingProps={this.props} dealerOperations={this.props.dealerOperations || null}/>
                            </MDBCol>
                        </MDBCol>

                        {/* Average Score Per Chapter Element */}
                        <MDBCol lg="4" md="4" >
                            <MDBCol lg="12" md="12" className="ket-widget" >
                                <AverageScoreChapter existingProps={this.props} dealerOperations={this.props.dealerOperations || null}/>
                            </MDBCol>
                        </MDBCol>

                        {/* Score Of Sub-questions Element */}
                        <MDBCol lg="4" md="4">
                            <MDBCol lg="12" md="12" className="ket-widget">
                                <ScoreTable customHeight="36rem" existingProps={this.props} dealerOperations={this.props.dealerOperations || null}/>
                            </MDBCol>
                        </MDBCol>
                </MDBRow>
                }
                </div>
            }
            </>
        );
    }
}
export default withRouter((withTheme(DealerWidgetContainer)));